import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "ng-select";
import { SimpleFilterInputEmptyComponent, SimpleFilterInputSelectValueComponent, SimpleFilterComponent, SimpleFilterInputBetweenValuesComponent, SimpleFilterInputSingleValueComponent, SimpleFilterInputBetweenDateValuesComponent, SimpleFilterInputBetweenEncerramentoValuesComponent } from "./simple-filter.component";
import { SimpleFilterInputDirective } from "./simple-filter-input.directive";
import { NgxMaskModule } from "ngx-mask";

@NgModule({
    declarations: [
        SimpleFilterComponent,
        SimpleFilterInputDirective,
        SimpleFilterInputEmptyComponent,
        SimpleFilterInputSingleValueComponent,
        SimpleFilterInputBetweenValuesComponent,
        SimpleFilterInputSelectValueComponent,
        SimpleFilterInputBetweenDateValuesComponent,
        SimpleFilterInputBetweenEncerramentoValuesComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgxMaskModule,
        SelectModule
    ],
    entryComponents: [
        SimpleFilterInputEmptyComponent,
        SimpleFilterInputSingleValueComponent,
        SimpleFilterInputBetweenValuesComponent,
        SimpleFilterInputSelectValueComponent,
        SimpleFilterInputBetweenDateValuesComponent,
        SimpleFilterInputBetweenEncerramentoValuesComponent,
    ],
    exports: [
        SimpleFilterComponent
    ]
})
export class SimpleFilterModule {

}